import { Component, computed, inject, OnInit } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { NavigationEnd, Router } from '@angular/router'
import { MatDialog } from '@angular/material/dialog'

import { map, startWith } from 'rxjs/operators'

import { ActionerRaised } from '@directives/actioner'
import { FullDateFilter, FullDateFilterState } from '@components/full-date-filter'
import { CdkLayoutState } from '@states/cdk-layout'

import { AppNavigation } from './ui/navigation'
import { AppHeader } from './ui/header'
import { AppContainer } from './ui/container'
import { MobileNav } from './ui/mobile-nav'
import { FirebaseService } from '@services/firebase-service'

@Component({
	selector: 'main-layout',
	template: `
		@if (isBrowser()) {
			<app-navigation />
		}
		<div>
			@if (isBrowser()) {
				<app-header />
			}
			@if (isOvernightReport()) {
				<app-container>
					<button type="button" actioner-raised color="main" (click)="openDialog()">
						{{ label() }}
					</button>
				</app-container>
			} @else {
				<app-container />
			}
		</div>
		@if (!isBrowser()) {
			<mobile-nav />
		}
	`,
	styleUrl: './main-layout.component.scss',
	imports: [AppNavigation, AppHeader, AppContainer, MobileNav, ActionerRaised],
})
export class MainLayoutComponent implements OnInit {
	readonly #router = inject(Router)
	readonly #matDialog = inject(MatDialog)
	readonly #cdkLayoutState = inject(CdkLayoutState)
	readonly #fullDateFilterState = inject(FullDateFilterState)
	readonly #firebaseService = inject(FirebaseService)

	readonly #isOvernightReport$ = this.#router.events.pipe(
		startWith(this.#router.url),
		map(e => {
			if (typeof e === 'string') {
				return e
			}

			if (e instanceof NavigationEnd) {
				return e.urlAfterRedirects
			}

			return ''
		}),
		map(url => url.includes('/overnight-report'))
	)
	readonly #isBrowser$ = this.#cdkLayoutState.isBrowser$

	readonly label = this.#fullDateFilterState.label
	readonly isBrowser = toSignal(this.#isBrowser$)
	readonly isOvernightReport = toSignal(this.#isOvernightReport$)
	readonly maxWidth = computed(() => {
		const isBrowser = this.isBrowser()

		return !isBrowser ? 'calc(100dvw - 2rem)' : '30rem'
	})

	ngOnInit(): void {
		this.#firebaseService.firebaseAuth().then(() => {
			console.log('🔥 Firebase auth success')
		})
	}

	openDialog(): void {
		this.#matDialog.open(FullDateFilter, {
			width: '100%',
			maxWidth: this.maxWidth(),
			panelClass: 'custom-dialog',
			backdropClass: 'custom-backdrop',
		})
	}
}
